"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var base_1 = require("./base");
var helper_1 = require("../utils/helper");
var constants_1 = require("../utils/constants");
var __1 = require("..");
var _inited;
// 存储到 IndexedDB 中
var setIntoIndexedDB = function (key, config) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, __1.Config.storeConfigInIndexedDB(key, config)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
// 获取 cdn 配置并存储到 IndexedDB
var getRemoteConfg = function () { return __awaiter(void 0, void 0, void 0, function () {
    var response, res, err_1, cacheConfig, reloadedResponse, reloadedRes, foodErrMsg, e_1, cacheConfig;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 13]);
                return [4 /*yield*/, fetch(helper_1.countryTimezoneCDNPath)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                res = _a.sent();
                return [4 /*yield*/, setIntoIndexedDB(constants_1.ConfigMap.ELVISHCOUNTRYTIMEZONE, res)];
            case 3:
                _a.sent();
                _inited = true;
                return [4 /*yield*/, (0, base_1.initBase)(res)];
            case 4: return [2 /*return*/, _a.sent()];
            case 5:
                err_1 = _a.sent();
                console.warn("ELvish Warning: ".concat((err_1 === null || err_1 === void 0 ? void 0 : err_1.message) || 'fetch countryTimezone.json error'));
                if (!(typeof window !== 'undefined')) return [3 /*break*/, 12];
                _a.label = 6;
            case 6:
                _a.trys.push([6, 11, , 12]);
                return [4 /*yield*/, __1.Config.getFromIndexedDB(constants_1.ConfigMap.ELVISHCOUNTRYTIMEZONE)];
            case 7:
                cacheConfig = _a.sent();
                if (cacheConfig) {
                    _inited = true;
                    return [2 /*return*/, (0, base_1.initBase)(cacheConfig)];
                }
                return [4 /*yield*/, (0, helper_1.fetchReloadCache)("".concat(helper_1.countryTimezoneCDNPath, "?time=").concat(new Date().valueOf()))];
            case 8:
                reloadedResponse = _a.sent();
                return [4 /*yield*/, reloadedResponse.json()];
            case 9:
                reloadedRes = _a.sent();
                return [4 /*yield*/, setIntoIndexedDB(constants_1.ConfigMap.ELVISHCOUNTRYTIMEZONE, reloadedRes)];
            case 10:
                _a.sent();
                foodErrMsg = 'Unexpected token v in JSON at position 0 phone';
                return [2 /*return*/, (0, base_1.initBase)(reloadedRes, foodErrMsg.indexOf(err_1 === null || err_1 === void 0 ? void 0 : err_1.message) > -1 ? foodErrMsg : '')];
            case 11:
                e_1 = _a.sent();
                console.warn("Elvish Fetch Warning: ".concat((err_1 === null || err_1 === void 0 ? void 0 : err_1.message) || '请求countryTimezone配置出错且无缓存可用'));
                cacheConfig = (0, helper_1.getApolloConfigFromLocal)(constants_1.Flag.COUNTRYTIMEZONE);
                if (!cacheConfig) {
                    throw Error("Elvish Fetch Error: \u672C\u5730 countryTimezone \u914D\u7F6E\u83B7\u53D6\u5931\u8D25");
                }
                return [2 /*return*/, (0, base_1.initBase)(cacheConfig)];
            case 12: return [3 /*break*/, 13];
            case 13: return [2 /*return*/];
        }
    });
}); };
// eslint-disable-next-line import/prefer-default-export
var init = function (_a) {
    var config = _a.config, ifCache = _a.ifCache, forceInit = _a.forceInit;
    return __awaiter(void 0, void 0, void 0, function () {
        var cacheConfig;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (forceInit) {
                        _inited = false;
                    }
                    if (_inited)
                        return [2 /*return*/, Promise.resolve()];
                    if (config) {
                        return [2 /*return*/, (0, base_1.initBase)(config.countryTimezone).then(function () {
                                _inited = true;
                            })];
                    }
                    if (!(typeof window !== 'undefined' && ifCache)) return [3 /*break*/, 2];
                    return [4 /*yield*/, __1.Config.getFromIndexedDB(constants_1.ConfigMap.ELVISHCOUNTRYTIMEZONE)];
                case 1:
                    cacheConfig = _b.sent();
                    // 如果没取到缓存，则从 cdn 拉取
                    if (!cacheConfig) {
                        return [2 /*return*/, getRemoteConfg().then(function (res) {
                                return res;
                            })];
                    }
                    return [2 /*return*/, (0, base_1.initBase)(cacheConfig).then(function () {
                            _inited = true;
                            fetch(helper_1.countryTimezoneCDNPath)
                                .then(function (res) { return res.json(); })
                                .then(function (res) {
                                setIntoIndexedDB(constants_1.ConfigMap.ELVISHCOUNTRYTIMEZONE, res);
                            })
                                .catch(function (err) {
                                console.warn('Elvish Warning: update countryTimezone IndexedDB error', err);
                            });
                        })];
                case 2: return [2 /*return*/, getRemoteConfg().then(function (res) {
                        return res;
                    })];
            }
        });
    });
};
exports.init = init;
